// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".search-cities-wrapper[data-v-21256b71]{background-color:transparent;margin-top:20px;padding:0}.search-cities-wrapper .content-link.is-closed>div[data-v-21256b71]:nth-child(n+6){display:none}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
